import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * Copyright (c) 2021 lingdocs.com
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
export function noPersInfs(s) {
  if ("mascSing" in s) {
    // this path shouldn't be used, just for type safety
    return s.mascSing;
  }

  return s;
}
export function pickPersInf(s, persInf) {
  if ("mascSing" in s) {
    return s[persInf];
  }

  return s;
} // export function pickPersInf(
//     s: T.OptionalPersonInflections<T.LengthOptions<T.PsString>>,
//     persInf: T.PersonInflectionsField,
// ): T.LengthOptions<T.PsString>;
// export function pickPersInf(
//     s: T.FullForm<T.PsString>,
//     persInf: T.PersonInflectionsField,
// ): T.SingleOrLengthOpts<T.PsString>;
// export function pickPersInf(
//     s: T.FullForm<T.VerbBlock>,
//     persInf: T.PersonInflectionsField,
// ): T.SingleOrLengthOpts<T.VerbBlock>;
// export function pickPersInf(
//     s: T.SplitInfo,
//     persInf: T.PersonInflectionsField,
// ): T.SingleOrLengthOpts<[T.PsString, T.PsString]>;
// export function pickPersInf(
//     s: T.OptionalPersonInflections<T.LengthOptions<T.PsString>> | T.FullForm<T.PsString> | T.FullForm<T.VerbBlock> | T.SplitInfo,
//     persInf: T.PersonInflectionsField,
// ): T.SingleOrLengthOpts<T.PsString> | T.LengthOptions<T.PsString> | T.SingleOrLengthOpts<T.VerbBlock> | T.SingleOrLengthOpts<[T.PsString, T.PsString]> {
//     if ("mascSing" in s) {
//         return s[persInf];
//     }
//     return s;
// }

export function hasPersInfs(info) {
  return "mascSing" in info.root.perfective || "mascSing" in info.stem.perfective || "mascSing" in info.participle.present || "mascSing" in info.participle.past;
}
export function chooseParticipleInflection(pPartInfs, person) {
  if ("long" in pPartInfs) {
    return {
      short: chooseParticipleInflection(pPartInfs.short, person),
      long: chooseParticipleInflection(pPartInfs.long, person)
    };
  }

  if ("masc" in pPartInfs) {
    var gender = personGender(person);
    var infNum = personIsPlural(person) ? 1 : 0;
    return pPartInfs[gender][infNum][0];
  }

  return pPartInfs; // already just one thing
}
export function getPersonNumber(gender, number) {
  var base = gender === "masc" ? 4 : 5;
  return base + (number === "singular" ? 0 : 6);
}
export function getPersonInflectionsKey(person) {
  return "".concat(personGender(person)).concat(personIsPlural(person) ? "Plur" : "Sing");
}
export function spaceInForm(form) {
  if ("mascSing" in form) {
    return spaceInForm(form.mascSing);
  }

  if ("long" in form) {
    return spaceInForm(form.long);
  }

  return form.p.includes(" ");
}
export function getPersonFromVerbForm(form, person) {
  if ("long" in form) {
    return Object.assign({
      long: getPersonFromVerbForm(form.long, person),
      short: getPersonFromVerbForm(form.short, person)
    }, form.mini ? {
      mini: getPersonFromVerbForm(form.mini, person)
    } : {});
  }

  var _getBlockRowCol = getBlockRowCol(person),
      _getBlockRowCol2 = _slicedToArray(_getBlockRowCol, 2),
      row = _getBlockRowCol2[0],
      col = _getBlockRowCol2[1];

  return form[row][col];
}
export function getBlockRowCol(person) {
  var plural = personIsPlural(person);
  var row = plural ? person - 6 : person;
  var col = plural ? 1 : 0;
  return [row, col];
}
export function getAuxTransitivity(trans) {
  return trans === "intransitive" ? "intransitive" : "transitive";
}
export function personGender(person) {
  return person % 2 === 0 ? "masc" : "fem";
}
export function personIsPlural(person) {
  return person > 5;
}
export function getEnglishPersonInfo(person) {
  var p = [0, 1, 6, 7].includes(person) ? "1st pers" : [2, 3, 8, 9].includes(person) ? "2nd pers" : "3rd pers";
  var a = personIsPlural(person) ? "plur" : "sing";
  var g = personGender(person);
  return "".concat(p, ". ").concat(a, ". ").concat(g, ".");
}
export function randomNumber(minInclusive, maxExclusive) {
  return Math.floor(Math.random() * (maxExclusive - minInclusive) + minInclusive);
}
/**
 * Sees if a possiblePerson (for subject/object) is possible, given the other person
 *
 * @param possiblePerson
 * @param existingPerson
 */

export function personIsAllowed(possiblePerson, existingPerson) {
  var isFirstPerson = function isFirstPerson(p) {
    return [0, 1, 6, 7].includes(p);
  };

  var isSecondPerson = function isSecondPerson(p) {
    return [2, 3, 8, 9].includes(p);
  }; // can't have both subject and object be 1st person


  if (isFirstPerson(possiblePerson) && isFirstPerson(existingPerson)) {
    return false;
  } // can't have both subject and object be 2nd person


  if (isSecondPerson(possiblePerson) && isSecondPerson(existingPerson)) {
    return false;
  } // otherwise it's ok


  return true;
}
/**
 * Picks a random person while assuring that the other person is not in conflict
 *
 * @param other
 */

export function randomPerson(other) {
  var newPerson;

  do {
    newPerson = randomNumber(0, 12);
  } while (!personIsAllowed(newPerson, other));

  return newPerson;
}
export function incrementPerson(p) {
  return (p + 1) % 12;
}
export function isSentenceForm(f) {
  if ("long" in f) {
    return isSentenceForm(f.long);
  }

  return Array.isArray(f) && "p" in f[0];
}
export function isNounAdjOrVerb(entry) {
  if (!entry.c) {
    return false;
  }

  if (entry.c.includes("adj.") || entry.c.includes("n. m.") || entry.c.includes("n. f.")) {
    return "nounAdj";
  }

  if (entry.c.slice(0, 3) === "v. ") {
    return "verb";
  }

  return false;
} // not being used
// export function isImperativeBlock(f: any): boolean {
//     function isPersonLine(g: any): boolean {
//         return Array.isArray(g) && Array.isArray(g[0]) && "p" in g[0][0];
//     }
//     return Array.isArray(f) && f.length === 2 && isPersonLine(f[0]);
// }